// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"258":"036493e6","401":"3fa819e3","727":"572ab18e"}[chunkId] + ".css";
};